import React from 'react';

import PositionedGoodyHOC from '../PositionedGoodyHOC';
import { POSITIONED_GOODY_REFS } from '../../../../constants';

export default class Baseball extends PositionedGoodyHOC {
	// 5
	render() {
		const style = {
			st49: {
				fill: '#4B9AE2',
			},
			st50: {
				fill: '#238BD8',
			},
		};
		return (
			<g>
				<circle ref={POSITIONED_GOODY_REFS.MARKER} cx="45.4579964" cy="45.6573067" />
				<path style={style.st49} d="M11.2912331,36.7030487c0,3.1619453,15.4767208,5.7252083,34.829792,5.7252083
					s33.8297958-2.5632629,33.8297958-5.7252083v-1.2722664c0-18.2690144-14.4767227-33.0789757-33.8297958-33.0789757
					S11.1852102,17.161768,11.1852102,35.4307823L11.2912331,36.7030487z" />
				<path style={style.st50} d="M72.9352875,40.2391968c1.1573486,0.0527344-5.2211227,2.6881905-17.8550377,6.7348213
					c-7.7006836,2.4665527-25.25-2.166748-34.25-2.666748S3.1515326,46.3645973,0.7294871,46.670536
					c-0.646527,0.0816689-0.9431157-0.7742996-0.3897915-1.1185379l12.223753-8.8489494
					c0,0,12.0964994-2.6598434,23.0167999-2.3957787C49.619606,34.646759,72.9352875,40.2391968,72.9352875,40.2391968z" />
				<path style={style.st50} d="M46.1224747,0.3072705h-2.2264709c-0.9983063,0-1.954525,0.4693882-1.9084015,1.5
					c0.0462837,1.0340286,0.8384972,1.5000001,1.9084015,1.5000001h2.2264709c0.9983101,0,1.9545288-0.4693882,1.9084015-1.5000001
					C47.9845963,0.7732419,47.192379,0.3072705,46.1224747,0.3072705z" />
				<path style={style.st50} d="M49.9557381,19.1305122c0.0310059-0.8183594-0.8842773-1.3217773-1.5588379-0.8574219l-4.279541,2.9460449
					c-1.6057129-1.5783691-4.1816406-3.5407715-7.1723633-3.6538086c-3.9150391-0.1481934-7.3747559,2.921875-8.7216797,4.2966309
					c-0.362793,0.3703613-0.3842773,0.9440918-0.0507812,1.3408203c1.2392578,1.4724121,4.4570312,4.795166,8.3723145,4.9433594
					c2.9907227,0.1130371,5.7072754-1.6489258,7.4277344-3.1015625l4.0446777,3.2609863
					c0.6376953,0.513916,1.5883789,0.0812988,1.6191406-0.7370605l-1.1142578-4.1376953L49.9557381,19.1305122z" />
				<polygon style={style.st49} points="36.068531,23.7003365 34.8505135,22.5601997 35.990406,21.3424263 35.2599373,20.6588326
					34.1202888,21.8763618 32.9025154,20.7364693 32.2189217,21.466938 33.436451,22.6065865 32.2960701,23.8248482
					33.0265388,24.5084419 34.1666756,23.2904243 35.3849373,24.4308052 " />
			</g>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Global/Goodies/Hat/Baseball.js